export const data_base = {

    // Lähtötilanne: seisotaan portaissa menosuunta alaspäin
    scene: '03_stairs_down',
    kysymysteksti: 'Mikä siirtyy ensin? Muista, vasen puoli on se kipeä puoli.',
    maxp: 1,
    optiot: [
        {
            id: 1,
            teksti: 'A molemmat sauvat',
            valinta: 'A',
            ohjaajan_palaute: '',
            koontiteksti: '',
            // pisteet: 1,
            // arviointitiedosto: 'scene_03_stairs_up_ok',

        },


        {

            id: 2,
            teksti: 'B oikea jalka',
            valinta: 'B',
            ohjaajan_palaute: '',
            koontiteksti: '',
            // pisteet: 0,
            // arviointitiedosto: 'scene_03_stairs_up_ei_ok',


        },
        {

            id: 3,
            teksti: 'C vasen jalka',
            valinta: 'C',
            ohjaajan_palaute: '',
            koontiteksti: '',
            // pisteet: 0,
            // arviointitiedosto: 'scene_03_stairs_up_ei_ok',


        }
    ]


};

export const data_A = {

    //Lähtötilanne: sauvat siirretty ala-askelmalle
    scene: '03_stairs_down',
    kysymysteksti: 'Siirretty sauvat alemmalle askelmalle - mitä seuraavaksi?',
    maxp: 1,
    optiot: [
        {
            id: 1,
            teksti: 'A laske vasen jalka sauvojen väliin',
            valinta: 'AA',
            ohjaajan_palaute: '',
            koontiteksti: '',
            // pisteet: 1,
            // arviointitiedosto: 'scene_03_stairs_up_ok',

        },


        {

            id: 2,
            teksti: 'B palauta sauvat takaisin',
            valinta: 'AB',
            ohjaajan_palaute: '',
            koontiteksti: '',
            // pisteet: 0,
            // arviointitiedosto: 'scene_03_stairs_up_ei_ok',


        },
        {

            id: 3,
            teksti: 'C laske oikea jalka sauvojen väliin',
            valinta: 'AC',
            ohjaajan_palaute: '',
            koontiteksti: '',
            // pisteet: 0,
            // arviointitiedosto: 'scene_03_stairs_up_ei_ok',


        }

    ]

};

export const data_AA = {

    //Lähtötilanne: sauvat ja vasen jalka siirretty ala-askelmalle (oikein tehty)
    scene: '03_stairs_down',
    kysymysteksti: 'Siirretty vasen jalka sauvojen kanssa samalle  askelmalle - mitä seuraavaksi?',
    maxp: 2,
    optiot: [
        {
            id: 1,
            teksti: 'A astu oikealla jalalla vasemman viereen',
            valinta: 'AAA',
            ohjaajan_palaute: '',
            koontiteksti: '',
            pisteet: 2,
            arviointitiedosto: 'scene_03_stairs_ok',

        },


        {

            id: 2,
            teksti: 'B astu oikealla yhtä seuraavalle askelmalle kuin millä vasen on',
            valinta: 'AAB',
            ohjaajan_palaute: '',
            koontiteksti: '',
            // pisteet: 0,
            // arviointitiedosto: 'scene_03_stairs_up_ei_ok',


        }
    ]

};

export const data_B = {

    // Lähtötilanne: laskettu oikea eli terve jalka ala-askelmalle ekana
    scene: '03_stairs_down',
    kysymysteksti: 'Siirretty oikea jalka alemmalle askelmalle - mitä seuraavaksi?',
    maxp: 1,
    optiot: [
        {
            id: 1,
            teksti: 'A palauta oikea jalka takaisin',
            valinta: 'BA',
            ohjaajan_palaute: '',
            koontiteksti: '',
        },

        {

            id: 2,
            teksti: 'B siirrä sauvat oikean jalan kanssa samalle askelmalle',
            valinta: 'BB',
            ohjaajan_palaute: '',
            koontiteksti: '',


        }


    ]


};

export const data_C = {

    // Lähtötilanne: laskettu vasen eli kipeä jalka ala-askelmalle ekana eli ennen sauvoja
    scene: '03_stairs_down',
    kysymysteksti: 'PENA HORJAHTI!',
    maxp: 1,
    optiot: [
    ]


};

